import { KitButton, KitContainedIcon, KitText } from '@omni/kit/components';
import { useTranslation } from '@omni/kit/hooks/useTranslation';
import Colors from '@omni/kit/theming/Colors';
import Spacing from '@omni/kit/theming/Spacing';
import React from 'react';
import { StyleSheet, View } from 'react-native';

const PhoneLoginDisabledScreen = ({
  reset,
}: {
  reset: () => void;
}): JSX.Element => {
  // ------------------------------------------------------------
  // Context & Custom Hooks

  const { t } = useTranslation(['auth']);

  return (
    <View style={[styles.contentContainer]}>
      <View style={styles.iconContainer}>
        <KitContainedIcon name='message' size='md' />
      </View>
      <View>
        <KitText center h1 style={styles.title} color={Colors.N900}>
          {t('auth:phoneLoginDisabled')}
        </KitText>
        <KitText center style={styles.subtitle} color={Colors.N900}>
          {t('auth:phoneLoginDisabledSubtitle')}
        </KitText>
      </View>
      <KitButton
        color={Colors.N1000}
        onPress={reset}
        title={t('auth:logInAnotherWay')}
      />
    </View>
  );
};

export default PhoneLoginDisabledScreen;

const styles = StyleSheet.create({
  contentContainer: {
    paddingHorizontal: Spacing.xl,
    marginBottom: Spacing.xxxxxl,
    maxWidth: 600,
  },
  iconContainer: {
    marginBottom: Spacing.l,
    alignItems: 'center',
  },
  title: {
    textAlign: 'center',
    marginBottom: Spacing.s,
  },
  subtitle: {
    textAlign: 'center',
    marginBottom: Spacing.xxl,
  },
});
